import { render, staticRenderFns } from "./app-layout.vue?vue&type=template&id=705f98e0&"
import script from "./app-layout.vue?vue&type=script&lang=ts&"
export * from "./app-layout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports